if (!customElements.get('gift-message')) {
  class GiftMessage extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.disclosure = this.querySelector('details-disclosure');
      this.buttonUpdate = this.querySelector('.js-gift-message-update');
      this.buttonRemove = this.querySelector('.js-gift-message-remove');
      this.itemKey = this.dataset.id
      this.cartItems = this.closest('cart-items');
  
      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }
  
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      this.init();
    }

    init() {
      this.buttonUpdate.addEventListener('click', this.handleBtnClick.bind(this));
      this.buttonRemove.addEventListener('click', this.handleRemoveBtnClick.bind(this));
    }

    handleBtnClick(e) {
      e.stopPropagation();
      e.preventDefault();
      this.handleNoteChange();
      this.disclosure?.close && this.disclosure?.close()
    }
    
    handleRemoveBtnClick(e){ 
      e.stopPropagation();
      e.preventDefault();
      this.handleNoteChange(true);
      this.disclosure?.close && this.disclosure?.close()
    }

    /**
     * Handle Note Change
     * @param {Boolean} remove - Remove note 
     */
    handleNoteChange(remove) {
      if (remove) {
        this.props = {}
      } else {
        this.props = [...this.querySelectorAll('input, textarea')].reduce((accumulator, currentValue, i) => {
          accumulator[currentValue.getAttribute('name')] = currentValue.value
  
          return accumulator
        }, {})
      }

      this.fetchRequestOpts.body = JSON.stringify({ 
        id: this.itemKey,
        properties: this.props
      });

      this.enableLoading()

      fetch(theme.routes.cartChange, this.fetchRequestOpts)
        .then(() => {
          this.cartItems?.refresh();
        })
        .finally(() => {
          setTimeout(() => {
            this.disableLoading();
          }, 500);
        })
    }
    
    /**
     * Shows a loading icon over line items.
     */
    enableLoading() {
      this.cartItems?.classList.add('pointer-events-none');

      const loader = this.cartItems?.querySelector(`.cart-item__loader`);
      if (loader) loader.hidden = false;

      document.activeElement.blur();
    }

    /**
     * Hides a loading icon over line items.
     */
    disableLoading() {
      this.cartItems?.classList.remove('pointer-events-none');

      const loader = this.cartItems?.querySelector(`.cart-item__loader`);
      if (loader) loader.hidden = true;
    }
  }
  customElements.define('gift-message', GiftMessage);
}
